// Default region code - can be overridden
const DEFAULT_REGION_CODE = "US";

// Function to detect user's region from browser locale
export function detectUserRegion(): string {
  try {
    if (typeof window !== "undefined" && window.navigator) {
      // Get the browser's language setting (e.g., "en-US", "de-DE", "fr-FR")
      const locale = navigator.language || navigator.languages?.[0];

      if (locale) {
        // Extract country code from locale (e.g., "US" from "en-US")
        const countryCode = locale.split("-")[1]?.toUpperCase();

        if (countryCode && countryCode.length === 2) {
          return countryCode;
        }
      }
    }
  } catch (error) {
    console.log("Could not detect user region:", error);
  }

  return DEFAULT_REGION_CODE;
}
